import { EntityListContentItem } from '../entityListTypes';
import { EntityListContentStructure } from './EntityListContentStructure';

export class SkuQuantityEntityListContentStructure implements EntityListContentStructure {
  getContentTableStructure(): EntityListContentItem[] {
    return [
      EntityListContentItem.PRODUCT,
      EntityListContentItem.STORE,
      EntityListContentItem.QUANTITY,
    ];
  }

  getContentObjectPath(contentItem: EntityListContentItem): string[] {
    switch (contentItem) {
      case EntityListContentItem.STORE:
        return ['sku', 'store'];
      case EntityListContentItem.PRODUCT:
        return ['sku', 'product'];
      case EntityListContentItem.QUANTITY:
        return ['quantity'];
    }
  }
}
